import React from "react";
import { Check, AlertTriangle, AlertCircle } from "lucide-react";
import colorGroups from "./__ColorGroups";
import ShowGroupColors from "./__ShowGroupColors";

const backgroundColors = colorGroups.find(
  (group) => group.group === "Background Colors"
);

const borderColors = colorGroups.find(
  (group) => group.group === "Border Colors"
);

const BackgroundBorderSection: React.FC = () => (
  <div className="w-full flex flex-col bg-bg-base px-4">
    <div className="container mx-auto max-w-3xl py-20">
      <div className="flex items-center justify-center">
        <img
          src="/images/logo-square.png"
          alt="RepMates logo"
          width="512"
          height="512"
          className="w-24 h-auto"
        />
      </div>

      <h1 className="text-5xl md:text-6xl font-extrabold text-tx-dark text-center leading-tight mb-10">
        Background & Border
      </h1>

      <div className="w-full bg-white  border border-bd-base rounded-lg p-4 md:p-20 mb-10">
        {backgroundColors && (
          <ShowGroupColors
            colorGroup={backgroundColors}
            gridColsClass="md:grid-cols-1"
          />
        )}
      </div>

      <div className="w-full bg-white border border-bd-base rounded-lg p-4 md:p-20 mb-10">
        {borderColors && (
          <ShowGroupColors
            colorGroup={borderColors}
            gridColsClass="md:grid-cols-1"
          />
        )}
      </div>

      <div className="w-full bg-white border border-bd-base rounded-lg p-4 md:p-20">
        <h2 className="text-2xl font-bold text-tx-dark mb-4">示例</h2>
        <div className="p-10  bg-bg-base rounded-lg border border-bd-base">
          <p className="text-sm mb-8 font-bold">bg-base + bd-base</p>

          <div className="p-6 mb-8 bg-bg-light rounded-lg border border-bd-base">
            <p className="text-sm mb-8">bg-light + bd-base</p>
            <div className="p-6  bg-bg-overlay rounded-lg border border-bd-overlay">
              <p className="text-sm">bg-overlay + bd-overlay</p>
            </div>
          </div>

          <div className="p-6  bg-bg-overlay rounded-lg border border-bd-overlay">
            <p className="text-sm py-3">bg-overlay + bd-overlay</p>
            <div className="p-6  bg-bg-light rounded-lg border border-bd-light">
              <p className="text-sm">bg-light + bd-light</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BackgroundBorderSection;
